import React from 'react';

const AnalysisResultSection = ({ result, onUpdateAnswers }) => {
  return (
    <section className="px-4 py-8 bg-slate-50 border-t border-white">
      <div className="mb-2 flex items-center gap-2">
        <div className="flex h-2 w-2 relative">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
        </div>
        <span className="text-[10px] font-bold text-accent uppercase tracking-widest">Analysis Completed</span>
      </div>

      <div className="bg-white border border-blue-100 rounded-2xl p-6 shadow-soft relative overflow-hidden ring-4 ring-blue-100/30">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-btn-primary to-accent"></div>
        
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-btn-primary/10 flex items-center justify-center text-blue-btn-primary">
              <span className="material-symbols-outlined">analytics</span>
            </div>
            <div>
              <h2 className="text-lg font-bold text-slate-900 leading-tight">
                Niitaの回答 
                <span className="text-[10px] font-normal text-white bg-blue-btn-primary px-1.5 py-0.5 rounded ml-1 align-middle">簡易</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-blue-50/50 rounded-xl p-4 border border-blue-100">
            <p className="text-slate-900 font-bold leading-relaxed text-base">
              今は<span className="text-blue-btn-primary text-lg font-black mx-1">『{result.sign}』</span>の
              <span className="block md:inline">サインがあるかもしれません</span>
            </p>
            <div className="mt-3 flex gap-2 items-start">
              <span className="material-symbols-outlined text-blue-btn-primary !text-sm mt-0.5">info</span>
              <p className="text-xs text-slate-600 leading-relaxed">
                {result.description}
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3 flex items-center gap-1">
              <span className="material-symbols-outlined !text-sm">manage_search</span>
              判断の理由
            </h3>
            <ul className="space-y-2">
              {result?.reasons?.map((reason, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-slate-600">
                  <span className="material-symbols-outlined text-accent !text-lg">check_small</span>
                  {reason}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3 flex items-center gap-1">
              <span className="material-symbols-outlined !text-sm">tips_and_updates</span>
              今日からできること
            </h3>
            <ul className="space-y-2.5">
              {result?.actions?.map((action, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-slate-600 bg-gray-50 p-2.5 rounded-lg">
                  <span className="text-blue-btn-primary font-bold">•</span>
                  {action}
                </li>
              ))}
            </ul>
          </div>

          <div className="pt-5 border-t border-gray-100 text-center">
            <div className="inline-block bg-blue-btn-primary text-white px-4 py-1.5 rounded-full text-sm font-bold mb-3 shadow-md shadow-blue-btn-primary/20">
              ケアの方向性：{result.result}
            </div>
            <p className="text-xs text-text-body font-medium mb-4 flex items-center justify-center gap-1">
              <span className="material-symbols-outlined text-accent !text-sm">forest</span>
              この積み重ねが、未来の髪のコンディションにつながります。
            </p>
            <button 
              onClick={onUpdateAnswers}
              className="text-xs text-slate-500 underline hover:text-blue-btn-primary transition-colors"
            >
              回答を更新する
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalysisResultSection;
